import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { LuMinus, LuPlus } from "react-icons/lu";
import "./_canvasOverlay.scss";

/**
 * Floating zoom widget anchored to the bottom-right grey area of the canvas.
 * Minus / percentage / plus — clicking the percentage resets to 100%.
 */
const CanvasZoomControl = ({ zoom = 1, min, max, onZoom, onReset, style }) => {
  const pct = Math.round((zoom || 1) * 100);
  const atMin = typeof min === "number" && zoom <= min + 1e-6;
  const atMax = typeof max === "number" && zoom >= max - 1e-6;

  const run = (fn) => (e) => {
    fn();
    e.currentTarget.blur();
  };

  return (
    <div className="canvasOverlay canvasOverlay--zoom" style={style}>
      <button
        type="button"
        className="canvasOverlayBtn"
        title={i18n.t("clipboard.zoomOut")}
        disabled={atMin}
        onClick={run(() => onZoom("out"))}
      >
        <LuMinus size={18} />
      </button>
      <button
        type="button"
        className="canvasOverlayZoomLabel"
        title={i18n.t("clipboard.zoomReset")}
        onClick={run(onReset)}
      >
        {pct}%
      </button>
      <button
        type="button"
        className="canvasOverlayBtn"
        title={i18n.t("clipboard.zoomIn")}
        disabled={atMax}
        onClick={run(() => onZoom("in"))}
      >
        <LuPlus size={18} />
      </button>
    </div>
  );
};

CanvasZoomControl.propTypes = {
  zoom: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  onZoom: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  style: PropTypes.object,
};

export default CanvasZoomControl;
